// CardSection.js
import React, {
	useEffect,useState
} from 'react';
import {
	Elements, StripeProvider
} from 'react-stripe-elements';

import Form from './Form';

const CardSection = (props) => {
	return (
		<StripeProvider apiKey={props.stripePublicKey}>
			<Elements
				fonts={[
					{
						src: 'url(https://dtxh53x5zi43j.cloudfront.net/fonts/maax/regular-205tf.woff)',
						family: 'Maax',
					}]}
			>
				<Form {...props} />
			</Elements>
		</StripeProvider>
	);
};

export default CardSection;
